import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import PropTypes from "prop-types";
import TestParserOutputDialog from './TestParserOutputDialog';
import { observable } from 'mobx';


class ParserErrorsDialog extends Component {

  state = observable({
    testParserOutputDialog: {
      open: false,
      values: [],
      hideParserId: true
    },
  })

  handleShowRowData = (row) => {
    this.state.testParserOutputDialog.values = row;
    this.state.testParserOutputDialog.open = true
  }

  handleCloseRowData = () => {
    this.state.testParserOutputDialog.values = [];
    this.state.testParserOutputDialog.open = false;
  } 

  render () {
    const me = this,
      props = this.props,
      { store } = props;

    return (
      <Dialog
        open={props.open}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
      >

        <DialogContent >
          <Typography variant="h6">Parser Errors</Typography>
          <Typography variant="body1"> {props.values.length == 0 && "No errors"} </Typography>
          { props.values.map((value, key) => {
              let error = value.error,
                date;
                try {
                  let errors = JSON.parse(error);
                  error = "";
                  errors.forEach(e => {
                    error = error ? error + ",": error;
                    error = error + e;
                  });
                } catch (e) {

                }

                date = new Date(value.date);
                date = date.toLocaleString();
              return (
                <div>
                  <Typography variant="body1" >{key + 1}. Validation Errors : {error}  
                    <a onClick={me.handleShowRowData.bind(me, value.row)}>row</a>
                  </Typography>
                  <Typography variant="body1"  style={{padding: "0 0 0 16px"}}> Executed at : {date} 
                  </Typography>
              </div>
              )
            })
          }

          {
            this.state.testParserOutputDialog.open && 
              <TestParserOutputDialog {...this.state.testParserOutputDialog} onClose={me.handleCloseRowData} />
          }

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={props.onClearErrors.bind(props.onClearErrors, props.templateId)}>
            Clear Errors
          </Button>
          <Button onClick={props.onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}


ParserErrorsDialog.propTypes = {
  values: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClearErrors: PropTypes.func.isRequired
};


export default observer(ParserErrorsDialog);
